<template>
  <div class="home">
    <!-- 头图 -->
    <div class="top">
      <img class="top-img" src="../assets/KV.jpeg" alt="" />
    </div>

    <!-- 只有备份防不住勒索病毒 -->
    <div class="title-box">
      <div class="title-info">勒索病毒环游记之速度与激情篇</div>
    </div>
    <!-- <div class="title-detail">不断创新的数据保护专家</div> -->
    <div class="backups-box">
      <img class="backups-img" src="../assets/beifen.png" alt="" />
      <div class="backups-info" @click="toUrl">
        <div class="backups-info-text">
          各位好，我是勒索软件部主管小R，主业“绑架”企业数据，副业写游记。本次新作《速度与激情篇》为读者特别分享我在汽车制造行业中的勒索“见闻”，但不巧遇见TA……
        </div>
      <a href="https://www.doit.com.cn/p/480600.html" class="backups-btn">阅读全文</a>
      </div>

    </div>

    <!-- 保护数据难难难 -->
    <!-- <div class="center-box">
      <a href="https://www.doit.com.cn/p/477867.html">
        <img style="width:100%" src="../assets/center-img.jpg" alt="" />
      </a>

    </div> -->

    <!-- 数据保护黄金法则 -->
    <div class="title-box">
      <div class="title-info1">
        4-3-2-1-0数据保护黄金法则防范企业数据的“至暗时刻”
      </div>
    </div>
    <div class="title-detail dl">
      戴尔科技集团建议您在保护核心数据时遵从4-3-2-1-0数据保护黄金法则，全面构建完善可靠的数据保护体系，应对新变局下的内外挑战。
    </div>
    <div class="mode-box">
      <div class="mode-item" v-for="(item, index) in modeList" :key="index">
        <img class="mode-img" :src="item.img" alt="" />
        <div class="mode-num">{{ item.num }}</div>
        <div class="hr"></div>
        <div class="mode-title">{{ item.title }}</div>
      </div>
    </div>

    <!-- 数据保护坚实根基 -->
    <div class="download-box">
      <div class="title-box">
        <div class="title-info">数据保护战略动员</div>
      </div>
      <div class="download-detail">
        <div
          class="download-item"
          v-for="(item, index) in downLoadLits"
          :key="index"
        >
          <img class="down-img" :src="item.img" alt="" />
          <div class="item-info">
            <div class="left">
              <img class="wenjian-img" src="../assets/wenjian.png" alt="" />
              <div class="info-titles">{{ item.title }}</div>
            </div>
            <img
              class="dw-img"
              src="../assets/xiazai.png"
              alt=""
              @click="downLoad(item)"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 数据避风港 -->
    <div class="title-box">
      <div class="title-info">数据保护行动指南</div>
    </div>
    <div class="video-box">
      <div class="video-top">
        <div
          class="top-item"
          v-for="(item, index) in topList"
          :key="index"
          @mouseover="mouseOver(item)"
          :class="{ on: item.id == select }"
          @mouseleave="mouseLeave"
          @click="topTO(item)"
        >
          <img class="top-img" :src="item.img" alt="" />
          <div class="top-bottom" v-if="item.id == 1">
            <img class="play-img" src="../assets/bofang.png" alt="" />
            <div>
              <!-- <div class="top-text">{{ item.title }}</div> -->
              <!-- <div class="top-text">{{ item.info }}</div> -->
            </div>
          </div>
          <!-- <div class="top-top" v-if="item.id == 2">{{ item.title }}</div> -->
          <div class="top-btn" v-if="item.id == 2">阅读全文</div>
        </div>
      </div>

      <div class="video-content">
        <div
          class="content-item"
          v-for="(item, index) in cententList"
          :key="index"
          @click="toVideo(item)"
        >
          <img class="top-img" :src="item.img" alt="" />
          <div class="top-bottom">
            <img class="play-img" src="../assets/bofang.png" alt="" />
            <div>
              <!-- <div class="top-text">{{ item.title }}</div> -->
              <!-- <div class="top-text">{{ item.info }}</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 数据保护保驾护航 -->
    <div class="protect">
      <div class="title-box">
      <div class="title-info">数据保护面面俱到</div>
    </div>
    <div class="protect-box">
      <div class="protect-item" v-for="(item,index) in protectList" :key="index" @click="toVideo(item)" >
        <img class="biaoji-img" src="../assets/biaoji.png" alt="">
        <div class="protect-title">{{item.title}}</div>
      </div>
    </div>
    </div>

    <!-- 底部声明 -->
    <div class="footer">
      <div class="footer-text">*戴尔的常规条款和条件在此适用，并可网上获得或致函索取。戴尔会尽力排查报价错误或其他错误，但由于我们的疏漏，某些错误仍可能发生。戴尔有权利不接受任何包含错误信息的订单。以上图片仅供参考。戴尔、戴尔标志、the stylized E logo, E-Value, Easy as Dell, Dimension, OptiPlex, Inspiron, Latitude, Dell Precision, PowerEdge, PowerVault, PowerConnect, Dell OpenManage, CompleteCover, Premier Access, DellNet, SmartStep, TrueMobile, Axim是Dell Inc.的注册商标或商标。Ultrabook、赛扬、Celeron Inside、Core Inside、英特尔、英特尔标志、英特尔凌动、Intel Atom Inside、英特尔酷睿、Intel Inside、Intel Inside 标志、英特尔博锐、安腾、Itanium Inside、奔腾、Pentium Inside、vPro Inside、至强、至强融核、Xeon Inside 和英特尔傲腾是英特尔公司或其子公司在美国和/或其他国家（地区）的商标。微软、微软标识和Windows是微软公司在美国和其他国家的商标/注册商标。文中提及的其他商标或商品名称均指拥有该商标或名称的机构或其产品。戴尔不拥有其他机构的商标和商品名称的相关权益。</div>
      <div class="footer-text">“Dell® / EMC ® / Dell EMC ® “ 等品牌商标将有可能同时出现在戴尔易安信相关企业级产品 (包括硬件和软件)， 和/或产品资料、戴尔易安信的官方网站。 如果您有有关戴尔易安信产品相关的任何疑问，欢迎联系您的指定客户经理。</div>
      <div class="daer-logo"><img class="logo-img" src="../assets/daierlogo.png" alt=""></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Home',
  components: {},
  data () {
    return {
      modeList: [
        {
          id: 1,
          img: require('../assets/kaobei.png'),
          num: '4份',
          title: '拷贝'
        },
        {
          id: 2,
          img: require('../assets/huifu.png'),
          num: '3个',
          title: '恢复点'
        },
        {
          id: 3,
          img: require('../assets/baohu.png'),
          num: '2种',
          title: '保护方式'
        },
        {
          id: 4,
          img: require('../assets/yidi.png'),
          num: '一套',
          title: '异地容灾'
        },
        {
          id: 5,
          img: require('../assets/shujudiushi.png'),
          num: '0',
          title: '数据丢失'
        }
      ], // 保护法则列表
      downLoadLits: [
        {
          id: 1,
          img: require('../assets/powerprotect数据表.png'),
          title: 'ESG研究摘要-重视网络弹性 助力业务创新',
          herf:
            'https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/205151481/2205172675773585?v=media&utm_source=fy23q2-doit&utm_medium=ot_md_md&utm_campaign=dps_library&utm_content=helen-wu&utm_term=dps_library'
        },
        {
          id: 2,
          img: require('../assets/案例配图1.png'),
          title: 'ESG技术验证报告——Cyber Recovery',
          herf:
            'https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/205103132/2104162762505841?v=media&utm_source=fy23q2-doit&utm_medium=ot_md_md&utm_campaign=dps_library&utm_content=helen-wu&utm_term=dps_library'
        },
        {
          id: 3,
          img: require('../assets/DPS1.png'),
          title: 'Dell EMC 的 PowerProtect DD 数据保护专用存储设备系列提供了快速高效的数据保护存储',
          herf:
            'https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/205053103/158341?v=media&utm_source=fy23q2-doit&utm_medium=ot_md_md&utm_campaign=dps_library&utm_content=helen-wu&utm_term=dps_library'
        },
        {
          id: 4,
          img: require('../assets/dps04.png'),
          title: '技术白皮书_Dell EMC PowerProtect Data Manager 动态NAS 保护',
          herf:
            'https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/205134322/2112250828465404?v=media&utm_source=fy23q2-doit&utm_medium=ot_md_md&utm_campaign=dps_library&utm_content=helen-wu&utm_term=dps_library'
        },
        {
          id: 5,
          img: require('../assets/dps02.png'),
          title: 'ESG研究摘要_数据存储领域的网络弹性成熟度',
          herf:
            'https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/205151480/2205173619508223?v=media&utm_source=fy23q2-doit&utm_medium=ot_md_md&utm_campaign=dps_library&utm_content=helen-wu&utm_term=dps_library'
        },
        {
          id: 6,
          img: require('../assets/dps03.png'),
          title: '戴尔数据避风港 Dell digital 客户案例',
          herf:
            'https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/205148821/2204263081140180?v=media&utm_source=fy23q2-doit&utm_medium=ot_md_md&utm_campaign=dps_library&utm_content=helen-wu&utm_term=dps_library'
        }
      ], // 数据保护列表
      select: -1,
      topList: [
        {
          id: 1,
          img: require('../assets/suo.jpg'),
          title: '戴尔网络弹性解决方案视频',
          info: 'PowerProtect DD 重新定义下一代数据保护！',
          href:
            'https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/details/2203223939787761?v=media&utm_source=fy23q2-doit&utm_medium=ot_md_md&utm_campaign=dps_library&utm_content=helen-wu&utm_term=dps_library'
        },
        {
          id: 2,
          img: require('../assets/right-img.png'),
          title: 'ESG报告_如何打造一个具有网络弹性，能创新、有发展的企业',
          href: 'https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/205151482/2205173217607784?v=media&utm_source=fy23q2-doit&utm_medium=ot_md_md&utm_campaign=dps_library&utm_content=helen-wu&utm_term=dps_library'
        }
      ], // 视频头部数据
      cententList: [
        {
          id: 1,
          img: require('../assets/founder.png'),
          title: '招招致胜,数据安全的"立体式"防御体系',
          info: '戴尔数据保护解决方案客户案例视频',
          href:
            'https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/details/2202222945438892?v=media&utm_source=fy23q2-doit&utm_medium=ot_md_md&utm_campaign=dps_library&utm_content=helen-wu&utm_term=dps_library'
        },
        {
          id: 2,
          img: require('../assets/sd3.png'),
          title: '应对数据风险的最佳策略',
          info: '久经验证的现代化解决方案',
          href:
            'https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/details/2203173450710876?v=media&utm_source=fy23q2-doit&utm_medium=ot_md_md&utm_campaign=dps_library&utm_content=helen-wu&utm_term=dps_library'
        },
        {
          id: 3,
          img: require('../assets/自信的.png'),
          title: '“勒索软件时代的数据保护”线上交流会',
          info: '',
          href:
            'https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/details/2110263328865385?v=media&utm_source=fy23q2-doit&utm_medium=ot_md_md&utm_campaign=dps_library&utm_content=helen-wu&utm_term=dps_library'
        },
        {
          id: 4,
          img: require('../assets/sd5.png'),
          title: '戴尔多云数据保护解决方案',
          info: '',
          href:
            'https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/details/2203221732020809?v=media&utm_source=fy23q2-doit&utm_medium=ot_md_md&utm_campaign=dps_library&utm_content=helen-wu&utm_term=dps_library'
        }
      ], // 视频内容数据
      protectList: [
        {
          id: 1,
          title: '黑客：你要悄悄变富，然后惊艳所有人……',
          href: 'https://mp.weixin.qq.com/s/lZ0pB4x7gql4jWzeAbPuqA'
        },
        {
          id: 2,
          title: '这招“三板斧”，勒索病毒谁敢接着？',
          href: 'https://mp.weixin.qq.com/s/4wmUmqWkJe9Z4vdZzm1SOA'
        },
        {
          id: 3,
          title: 'DPS“老司机”登场，请多指教！',
          href: 'https://mp.weixin.qq.com/s/zlOFSnoIyVQQUMXJcykbvA'
        },
        {
          id: 4,
          title: '勒索病毒环游记',
          href: 'https://www.doit.com.cn/p/477867.html'
        }
      ], // 数据保护保驾护航
      appId: 'wxfbe93b3cbd8ecd98'// appId
    }
  },
  mounted () {
    this.share()
  },
  methods: {
    // 下载文件
    downLoad (item) {
      window.location.href = item.herf
    },

    // 鼠标移入事件
    mouseOver (item) {
      this.select = item.id
    },
    // 移出事件
    mouseLeave () {
      this.select = -1
    },
    // 视频头部跳转
    topTO (item) {
      window.location.href = item.href
    },
    // 前往视频详情
    toVideo (item) {
      window.location.href = item.href
    },
    // 查看全文
    toUrl () {
      window.location.href = 'https://www.doit.com.cn/p/475388.html'
    },
    // 分享
    share () {
      var path = {
        url: window.location.href.split('#')[0]
      } //* *重点** 这个路径只需要填写到index.html 就可以了（也就是编译后你放服务器上的访问路径）
      console.log(path.url)
      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
      axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded'
      axios.defaults.transformRequest = [function (data) {
        let ret = ''
        for (const it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }]
      axios.post('https://scrm.bydt.com.cn/wechat/dell-api/share?merchant_id=1', { url: path.url })
        .then((res) => {
          var e = res.data.data
          const _this = this
          _this.$wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数
            appId: e.appId, // 必填，公众号的唯一标识
            timestamp: e.timestamp, // 必填，生成签名的时间戳
            nonceStr: e.nonceStr, // 必填，生成签名的随机串
            signature: e.signature, // 必填，签名
            jsApiList: ['checkJsApi', 'updateAppMessageShareData',
              'updateTimelineShareData'
            ] // 必填，需要使用的JS接口列表
          })
          _this.$wx.ready(function () {
            _this.$wx.checkJsApi({
              jsApiList: ['updateAppMessageShareData',
                'updateTimelineShareData'
              ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
              success: function (res) {
                console.log('验证通过: ', res)
              }
            })

            _this.$wx.updateAppMessageShareData({

              title: '从边缘到核心到云，全面守护数智未来', // 分享标题
              desc: '久经考验的戴尔数据保护解决方案', // 分享描述
              link: path.url + '?t=' + e
                .timestamp, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致

              imgUrl: 'https://pic.doit.com.cn/dell/dps.png', // 分享图标

              success: function () {
                console.log('成功')
              }
            })

            _this.$wx.updateTimelineShareData({

              title: '从边缘到核心到云，全面守护数智未来', // 分享标题
              link: path.url + '?t=' + e
                .timestamp, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: 'https://pic.doit.com.cn/dell/dps.png', // 分享图标

              success: function () {
                console.log('成功')
              }
            })
          })
          _this.$wx.error(function (res) {
            console.log('验证失败:', res)
          })
        })
    }
  }
}
</script>
<style scoped>
.daer-logo{
  display: none;
}
.top {
  width: 100%;
  height: 576px;
}
.top-img {
  width: 100%;
}
.title-box {
  width: 100%;
  margin-top: 20px;
  position: relative;
}
.title-info1 {
  margin: 0 auto;
  font-family: MicrosoftYaHei-Bold;
  font-size: 18px;
  /* height: 50px; */
  font-weight: bold;
  font-stretch: normal;
  color: #00447c;
  background: url(../assets/标题框2.png) no-repeat center;
  background-size: 100% 100%;
  /* border-bottom: 1px solid #00447c; */
  display: inline-block;
  padding: 25px 35px;
  /* padding-bottom: 10px; */

}
.title-info {
  margin: 0 auto;
  font-family: MicrosoftYaHei-Bold;
  font-size: 18px;
  /* height: 50px; */
  font-weight: bold;
  font-stretch: normal;
  color: #00447c;
  background: url(../assets/标题框.png) no-repeat center;
  background-size: 100% 100%;
  /* border-bottom: 1px solid #00447c; */
  display: inline-block;
  padding: 25px 35px;
  /* padding-bottom: 10px; */

}
/* .title-box::after {
  position: absolute;
  content: "";
  width: 63px;
  height: 4px;
  background: #0076c8;
  right: 47%;
  bottom: -2.5px;
} */

.title-detail {
  font-family: MicrosoftYaHei;
  font-size: 22px;
  font-weight: 100;
  font-stretch: normal;
  color: #000000;
  margin-top: 14px;
}

.backups-box {
  margin-top: 35px;
  text-align: left;
  position: relative;
}

.backups-img {
  width:45%;
  margin-left: 18%;
}

.backups-info {
  position: absolute;
  width: 30%;
  height: 100%;
  background-color: #00447c;
  top: 20px;
  right: 18%;
  padding: 39px 37px;
  box-sizing: border-box;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  color: #ffffff;
  line-height: 2;
  cursor: pointer;
}

.center-box {
  width: 100%;
  height: 186px;
  margin-top: 93px;
}

.mode-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-top: 55px;
  padding-bottom: 50px;
}

.mode-item {
  width: 220PX;
  height: 340px;
  box-sizing: border-box;
  padding-bottom: 20px;
  background: #00447c;
  margin-right: 17px;
}

.mode-img {
  width: 161px;
  height: 161px;
  margin-top: 51px;
}

.mode-num {
  font-family: MicrosoftYaHei-Bold;
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  color: #ffffff;
  margin-top: 8px;
}

.mode-title {
  font-family: MicrosoftYaHei;
  font-size: 26px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #ffffff;
}

.hr {
  border: 1px solid #0076c8;
  width: 14px;
  margin: 6px auto;
}

.download-box {
  width: 100%;
  background: #f4f4f4;
  padding-top: 29px;
  padding-bottom: 40px;
}
.download-detail {
  /* width: calc(100vw - 700px); */
   width: calc(100vw - 420px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
  margin-top: 30px;
}

.download-item {
  width: 29%;
}

.down-img {
  width: 100%;
}

.item-info {
  display: flex;
  align-items: center;
  height: 50px;
  justify-content: space-between;
  width: 100%;
}

.info-titles {
  font-family: MicrosoftYaHei;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  color: #000000;
  text-align: left;
  margin-left: 10px;
}

.left {
  display: flex;
  align-items: center;
}

.video-top {
  width: 100%;
  height: 560px;
  background: url(../assets/video-top.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top-item {
  width: 530px;
  /* height: 433px; */
  border: 1px solid #000;
  margin-right: 26px;
  position: relative;
  cursor: pointer;
}

.top-item:last-child {
  margin-right: 0;
}

.on {
  width: 540px;
  /* height: 433px; */
  overflow: hidden;
  border: 1px solid #000;
}

.top-img {
  width: 100%;
}

.top-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 35%;
  background: rgba(0, 68, 124, 0.6);
  display: flex;
  align-items: center;
}

.play-img {
  width: 43px;
  height: 43px;
  margin-left: 24px;
  margin-right: 9px;
}

.top-text {
  font-family: MicrosoftYaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  color: #ffffff;
  text-align: left;
  opacity: 1;
  z-index: 9999;
}
.top-top {
  position: absolute;
  left: 10px;
  top: 10px;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  color: #ffffff;
  text-align: left;
  opacity: 1;
  width: 313px;
}

.top-btn {
  position: absolute;
  right: 20px;
  bottom: 10px;
  width: 120px;
  height: 30px;
  background-color: #ffffff;
  border-radius: 10px;
  border: solid 1px #021633;
  text-align: center;
  line-height: 30px;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  color: #000000;
}

.dw-img {
  cursor: pointer;
  width: 26px;
  height: 27px;
}

.video-content {
  width: calc(100vw - 660px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0 auto;
}
.content-item{
  width:44%;
  position: relative;
  margin-top: 15px;
  border: 1px solid #f4f4f4;
  cursor: pointer;
  margin-right: 15px;
}

.protect{
  width: 100%;
	/* height: 255px; */
	background-color: #f4f4f4;
  margin-top: 40px;
  padding-top: 10px;
  padding-bottom: 40px;
}

.wenjian-img{
  width: 33px;
  height: 37px;
}

.protect-box{
  width: 1269px;
  margin: 0 auto;
  margin-top: 24px;

}

.protect-item{
  width: 100%;
  height: 62px;
  display: flex;
  padding-left: 46px;
  box-sizing: border-box;
  align-items: center;
  cursor: pointer;
}

.protect-item:nth-of-type(1n){
  background: #00447c;
}

.protect-item:nth-of-type(2n){
  background: #0076c8;
}

.biaoji-img{
  width: 66px;
  height: 22px;
  margin-right: 12px;
}

.protect-title{
	font-family: MicrosoftYaHei-Bold;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	color: #ffffff;
}

.footer{
  width: 100%;
  height: 510px;
  background: url(../assets/footer.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
  padding-top: 88px;
  box-sizing: border-box;
}

.footer-text{
  width: 1282px;
  margin: 0 auto;
  font-family: MicrosoftYaHei;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	color: #ffffff;
  text-align: left;
}

.footer-text:nth-of-type(2){
  margin-top: 20px;
}

.dl{
  width: 100%;
  margin: 0 auto;
  text-align: center;
  margin-top: 20px;
}

.backups-btn{
  display: block;
	width: 130px;
	height: 40px;
	background-color: #ffffff;
	border-radius: 10px;
	border: solid 1px #021633;
  font-family: MicrosoftYaHei;
	font-size: 22px;
	font-weight: normal;
	font-stretch: normal;
	color: #000000;
  text-align: center;
  margin: 0 auto;
  margin-top: 40px;
  text-decoration:none
}

@media only screen and (min-width: 100px) and (max-width: 640px) {
  .home{
    width: 100%;
    overflow-x: hidden;
  }
  .top {
  width: 100%;
  height: 112px;
}
.backups-box {
  margin-top: 35px;
  text-align: left;
  position: relative;
}

.backups-img{
  width: 246px;
  height: 145px;
  margin-left: 10px;
}

.backups-info {
  position: absolute;
  width: 200px;
  height: 145px;
  background-color: #00447c;
  top: 20px;
  right: 10px;
  padding: 10px 10px;
  box-sizing: border-box;
  font-family: MicrosoftYaHei;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  color: #ffffff;
  cursor: pointer;
  line-height: 1;
}
.backups-info-text{

}

.title-detail{
  font-size: 10px;
  text-align: center;
}

.mode-item{
  width: 94px;
  height: 145px;
  margin-right: 5px;
}

.mode-img{
  width: 63px;
  height: 63px;
  margin-top: 20px;
}

.mode-num{
  font-size: 14px;
  margin: 0;
}

.mode-title{
  font-size: 10px;
}

.download-detail{
  width: calc(100vw - 50px);
}

.download-item{
  width: 154px;
}

.down-img{
  width: 154px;
  height: 105px;
}

.wenjian-img{
  width: 13px;
  height: 14px;
}

.info-titles{
  font-size: 6px;
  margin-left: 5px;
}

.dw-img{
  width: 10px;
  height: 11px;
}

.item-info{
 height: 20px;
 margin-bottom: 10px;
}

.video-top{
  height: 219px;
  background-size:100% 100%;
}

.top-item {
  width: 180px;
  height: 135px;
  border: 1px solid #000;
  margin-right: 13px;
  position: relative;
  cursor: pointer;
}

.top-item:last-child {
  margin-right: 0;
}

.on {
  width: 200px;
  height: 169px;
  border: 1px solid #000;
}

.top-bottom{
  height: 34px;
}

.play-img{
  width: 28px;
  height: 28px;
  margin-left: 10px;
}

.top-text{
  font-size: 8px;
}

.video-content{
  width: calc(100vw - 40px);
}

.content-item{
  width: 48%;
  height: 120px;
  margin-right: 0;
}

.protect-box{
  width: 396px;
}

.protect-item{
  width: 396px;
  height: 24px;
    padding-left: 36px;
  box-sizing: border-box;
}

.biaoji-img{
  width: 26px;
  height: 9px;
}
.protect-title{
  font-size: 12px;

}

.footer{
  padding: 0 10px;
  padding-top: 14px;
  box-sizing: border-box;
   background: #00447c;
   height: 100%;
   padding-bottom: 50px;
}

.footer-text{
width: 100%;
font-size: 6px;
}

.top-top{
  width: 150px;
  font-size: 12px;
}

.mode-box{
  padding: 0 10px;
  box-sizing: border-box;
}

.backups-btn{
  width: 120px;
  margin-top: 20px;
  font-size: 12px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.top-btn{
 width: 69PX;
 height: 20px;
 font-size: 10px;
 line-height: 20px;
}

.daer-logo{
  display: block;
  width: 160px;
  margin-top: 30px;
  margin-left: 200px;
}
.logo-img{
  width: 100%;
}

.video-content{
  justify-content: space-between;
}
}
</style>
